<div class="secondary-nav w-100 no-print">
  <div class="secondary-nav-contents clearfix bg-lavender">
    <ul class="nav menu-group menu-group-2 bg-lavender ml-2 custom-menu-group">
      <li class="nav-item">
        <a
          class="nav-link"
          routerLinkActive="active"
          [routerLink]="['/company', authService.companyUrlName, 'resource-planning', 'teams']"
          >{{ '$menu_resource_planning_teams$' | translate }}</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLinkActive="active"
          [routerLink]="['/company', authService.companyUrlName, 'resource-planning', 'board']"
          >{{ '$menu_resource_planning_board$' | translate }}</a
        >
      </li>
    </ul>
  </div>
</div>
